import React from "react";

const AboutMe = () => (
  <section className="py-5">
    <div className="container">
      <h2 className="mb-4 text-center fw-bold" style={{ letterSpacing: "1px" }}>
        About Me
      </h2>
      <div className="row justify-content-center">
        <div className="col-md-8">
          <div className="fs-5 text-center" style={{ lineHeight: 1.8 }}>
            <p>
              <span className="fw-semibold">Hi, I’m Mohonish Mullick</span> — an engineering leader with 11+ years of experience designing, building, and scaling full-stack software systems.
            </p>
            <p>
              I currently lead the ad-monetization team at PropertyGuru, crafting <span className="fw-semibold">NestJS</span> and <span className="fw-semibold">ReactJS</span> services, <span className="fw-semibold">MySQL</span> databases, and <span className="fw-semibold">RabbitMQ</span>-driven event pipelines that generating 40% of the revenue.
            </p>
            <p>
              Previously, I’ve architected <span className="fw-semibold">Magento-to-microservices migrations in Go</span>, built APIs in <span className="fw-semibold">Node.js</span> and <span className="fw-semibold">AWS Lambda</span>, created front-ends in <span className="fw-semibold">Vue.js</span> and <span className="fw-semibold">AngularJS</span>, and implemented DevOps and CI/CD pipelines across <span className="fw-semibold">Ruby on Rails</span>, <span className="fw-semibold">Spring Boot (Java)</span>, <span className="fw-semibold">PostgreSQL</span>, and <span className="fw-semibold">MongoDB</span> at Bizongo, Nua, and other fast-growth startups.
            </p>
            <hr className="my-4" style={{ opacity: 0.2 }} />
            <p>
              <span className="fw-semibold">Beyond code</span>, I’m a creative catalyst—shooting, mixing, and editing music videos, and contributing to music compositions. I bring the same focus on elegance and efficiency to every project, whether it’s a complex backend workflow or a multimedia production.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default AboutMe;